import usePageTitle from "hooks/usePageTitle";
import { PageWrapper, Intro, GridContainer, GridItem } from "./HomeStyle";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import ConnectSocials from "./ConnectSocials";
import { ChevronLeftIcon } from "icons/ArrowLeftIcon";
import AiAssitantSection from "./AiAssitantSection";
import MoreThings from "./MoreThings";
import Engagement from "./Engagement";
import Analytics from "./Analytics";
import PostStreakTracker from "./PostStreakTracker";
import PostSchedule from "./PostSchedule";
import HelperSection from "./HelperSection";
import ContentCard from "./ContentCard";

const HomeDashboard = ({ user }) => {
  usePageTitle("Home");
  const history = useHistory();

  return (
    <PageWrapper>
      <GridContainer columns="2fr 1fr" gap="24px">
        <GridContainer columns="1fr 1fr 1fr" gap="24px">
          <GridItem colSpan={3}>
            <Intro>
              <div className="intro_card">
                <header className="page-header">
                  Hello, {user?.first_name} 👋
                </header>
                <header className="body-2 colorGrey8">
                  How can I help you today?
                </header>
              </div>
            </Intro>

            <ConnectSocials />
          </GridItem>
          <GridItem colSpan={3}>
            <HelperSection />
          </GridItem>
          {/* <GridItem colSpan={3}>
            <Banner bg="#032250" />
          </GridItem> */}
          <GridItem colSpan={3}>
            <AiAssitantSection />
          </GridItem>
          <GridItem colSpan={3}>
            <MoreThings />
          </GridItem>
        </GridContainer>
        <GridItem bgColor="#fff">
          <PostSchedule />
        </GridItem>
      </GridContainer>
      <GridContainer columns="2fr 1fr" gap="24px" mt="24px">
        <Engagement />
        <GridContainer columns="1fr" gap="24px">
          <PostStreakTracker />
          <ContentCard
            header="Refer and earn"
            content="20% commission on referrals' payments for 6 months - build lasting income!"
            actionIcon={<ChevronLeftIcon color="#656575" size={16} />}
            className="card"
            onClick={() =>
              history.push("/dashboard/affiliate-program/overview")
            }
          />
        </GridContainer>
      </GridContainer>
      <Analytics />
    </PageWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(HomeDashboard);
